<div [formGroup]="form" class="informate_select_wrapper">
    <mat-label class="font-style" [ngbTooltip]="hubMaterial_tooltip" placement="right" container="body" tooltipClass="custom-tooltip">
        <!-- Hub Material -->
        {{ 'CLAMP_PAGE.LABELS.CALC_INPUT.HUB_MATERIAL' | transloco }}
    </mat-label>
    <!--tool-tip template start-->
    <ng-template #hubMaterial_tooltip>
        <p>
            {{ 'TOOLTIP.INFORMATE_CALC_LABELS.HUB_MATERIAL' | transloco }}
        </p>
    </ng-template>
    <!--tool-tip template end-->
    <mat-select
        formControlName="hubMaterial"
        name="hubMaterial"
        class="input-select"
        [class.spinner]="loading"
        (selectionChange)="selectHubMaterial($event)"
        [class.select-disable]="enable"
    >
        <mat-option class="option-list" *ngFor="let x of optionList" [value]="x.hubMaterialId">{{ x.name }}</mat-option>
    </mat-select>
</div>
